
import { adminConstants } from './constants';

var viewActions = require ('../../store/view.actions');
var adminService = require ('./api');

export const adminActions = {
    getAttencance,
    // updateParameter
};  


function getAttencance ( token, calendarID, topLevelID, shift, date ) { 
    return dispatch => {
        dispatch(viewActions.isLoadingModule('getAttencance',true)) ;

        adminService.getAttencance ( token, calendarID, topLevelID, shift, date )
        .then( json => {
            dispatch({
                type: adminConstants.GET_DAY_ATTENDANCE,
                dayAttendance: json
            })
            dispatch(viewActions.isLoadingModule('getAttencance',false)) ;
        } )
        
}
}

// function updateParameter ( token,  param_id, data, userID  ) { 
//     return dispatch => {
//         dispatch(viewActions.isLoadingModule('updating_'+param_id,true)) ;
       
//         setupService.updateParameter ( token,  param_id, data ) 
//         .then( json => {
//             dispatch({
//                 type: setupConstants.UPDATE_PARAMETER,
//                 param_id: param_id,
//                 data: data,
//                 userID: userID
//             })
//             dispatch(viewActions.isLoadingModule('updating_'+param_id,false)) ;
//         } )
//     }
// }
